export enum ImageFormat {
    Jpg = 'jpg',
    Jpeg = 'jpeg',
    Gif = 'gif',
    Png = 'png',
    Webp = 'webp',
}